export default __webpack_public_path__ + "static/media/logOutIcon.46b85b4e.svg";